<template>
  <div class="com-goole-vertify">
    <div class="title" :class="{ qr: show_qrcode }">
      <div class="desc">谷歌验证</div>
    </div>
    <div class="description" v-if="show_qrcode">
      第一次登录时需要打开Authenticator录入密钥
    </div>
    <div class="vertify-qr-code" v-if="show_qrcode">
      <canvas ref="vertify-qrcode" id="vertify-qrcode"></canvas>
      <p class="vertify-code">{{ normal_code }}</p>
    </div>
    <div class="input-container" v-else>
      <div class="input-item">
        <label :class="{ show: google_value }">谷歌密钥</label>
        <input
          type="text"
          v-model="google_value"
          placeholder="请输入密钥"
          ref="account"
        />
      </div>
    </div>
    <div class="btn-container">
      <div class="btn login" @click="vertify">
        {{ show_qrcode ? '去验证' : '验证' }}
      </div>
    </div>
  </div>
</template>
<script>
import { googleVertify } from '_api/account/login-v2';
import QRCode from 'qrcode';
export default {
  props: {
    vertifyInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      google_value: '',
      show_qrcode: false,
      normal_code: '',
    };
  },
  created() {
    this.show_qrcode = Boolean(this.vertifyInfo.uri);
    this.normal_code = this.vertifyInfo.new_secret;
  },
  mounted() {
    window.addEventListener('keydown', this.onKeyDown);
    if (this.show_qrcode) {
      this.setVertifyQrcode();
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onKeyDown(e) {
      if (e.keyCode == 13) {
        this.vertify();
      }
    },
    vertify() {
      if (this.show_qrcode) {
        this.show_qrcode = false;
      } else {
        googleVertify({
          user_id: this.vertifyInfo.heybox_id,
          code: this.google_value,
          _notip: true,
        }).then((res) => {
          if (res.data.status != 'ok') {
            this.$message.error(res.data.msg);
            return;
          }
          if (res.data.result.verify_res === false) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$emit('setUserInfo', res);
        });
      }
    },
    setVertifyQrcode() {
      QRCode.toCanvas(
        this.$refs['vertify-qrcode'],
        this.vertifyInfo.uri,
        {
          width: 184,
          height: 184,
        },
        (err) => {
          if (err) {
            this.$message.error(err);
          }
        },
      );
    },
  },
};
</script>
<style lang="less">
.com-goole-vertify {
  .title {
    display: flex;
    align-items: center;
    color: #14191e;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 30px;
    &.qr {
      margin-bottom: 10px;
    }
  }
  .description {
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(140, 145, 150, 1);
  }
  .vertify-qr-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 20px;
    #vertify-qrcode {
      width: 184px;
      height: 184px;
    }
    .vertify-code {
      font-size: 20px;
      font-weight: 800;
      line-height: 24px;
      color: #14191e;
      text-align: center;
      white-space: nowrap;
    }
  }
  .input-container {
    margin-bottom: 40px;
    .input-item {
      position: relative;
      &:not(:last-of-type) {
        margin-bottom: 30px;
      }
      label {
        display: block;
        color: #c8cdd2;
        font-size: 13px;
        line-height: 18px;
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
        &.show {
          opacity: 1;
          transform: translateY(0);
        }
      }
      input {
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        background: #fff;
        border: 0;
        border-bottom: 2px solid #e9ecf0;
        font-size: 20px;
        font-family: 'Baumans';
        line-height: 24px;
        padding: 8px 0 6px 0;
        transition: border-color 0.2s linear;
        &::-webkit-input-placeholder {
          position: relative;
          top: -2px;
          color: #c8cdd2;
          font-size: 15px;
        }
        &:focus {
          border-color: #14191e;
        }
        &::-webkit-autofill {
          background: #fff;
          &:focus {
            background: #fff;
          }
        }
      }
      .btn-code {
        z-index: 1;
        position: absolute;
        right: 3px;
        bottom: 6px;
        height: 26px;
        line-height: 24px;
        color: #8c9196;
        font-size: 14px;
        user-select: none;
      }
      .no-send {
        cursor: pointer;
        &:hover {
          color: #14191e;
        }
      }
    }
  }
  .btn-container {
    .btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 44px;
      background: #14191e;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(#fff, 0.1);
        border-radius: 4px;
        opacity: 0;
        transition: 0.2s linear;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
      .el-loading-mask {
        background: #14191e;
        border-radius: 4px;
        .circular {
          width: 24px;
          .path {
            stroke: #fff;
          }
        }
      }
    }
    .el-button {
      height: 44px;
      margin-bottom: 10px;
      &.wechat-login {
        background: #07c160;
        border-color: #07c160;
        &:hover,
        &:focus {
          background: #07cf68;
          border-color: #07cf68;
        }
        .wechat-icon {
          width: 20px;
          vertical-align: middle;
          margin-right: 5px;
          + span {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
